module.exports = __webpack_public_path__ + "static/media/kunshan03.c1a25403.jpg";